import React from 'react';

import type { TabItem } from 'src/components/common';
import { Tabs } from 'src/components/common';
import type { SxProp } from 'src/types/mui';

import { PaymentHistoryTable } from '../GeneralBillingTables';

import { ActiveBillingRates } from './ActiveBillingRates';

export const BillingTabs: React.FC = () => {
  return (
    <Tabs
      tabs={billingTabs}
      additionalTabsContainerStyles={{ margin: 0 }}
      contentStyles={contentStyles}
      containerProps={{ sx: containerStyles }}
    />
  );
};

const billingTabs: TabItem[] = [
  {
    key: 'Billing',
    label: 'Billing',
    component: <ActiveBillingRates />,
  },
  {
    key: 'Payment History',
    label: 'Payment History',
    component: <PaymentHistoryTable />,
  },
];

const containerStyles: SxProp = theme => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    flexBasic: '0%',
    flexDirection: 'column',
    height: '100%',
  },

  [theme.breakpoints.down('sm')]: {
    py: 2,
  },
});

const contentStyles: SxProp = {
  mt: 3,
};
